import _inheritsLoose from "@babel/runtime-corejs3/helpers/inheritsLoose";
import _concatInstanceProperty from "@babel/runtime-corejs3/core-js/instance/concat";
import _Array$from from "@babel/runtime-corejs3/core-js/array/from";
import { __decorate } from "tslib";
import { Component } from 'intact-vue-next';
import template from './index.vdt';
import { useNodes } from './useNodes';
import { bind } from '../utils';
import { useChecked } from './useChecked';
import { useExpanded } from './useExpanded';
import { useSelected } from './useSelected';
import { useFilter } from './useFilter';
import { useDraggable, Mode } from './useDraggable';
import { useTransitionEvent } from './useTransitionEvent';
import { useConfigContext } from '../config';
export { Mode as TreeMode };
var typeDefs = {
  data: Array,
  filter: Function,
  uncorrelated: Boolean,
  checkedKeys: Array,
  expandedKeys: Array,
  defaultExpandAll: Boolean,
  selectable: Boolean,
  selectedKeys: Array,
  multiple: Boolean,
  checkbox: Boolean,
  load: Function,
  showLine: Boolean,
  draggable: Boolean,
  allowDrag: Function,
  allowDrop: Function
};
var defaults = function defaults() {
  return {
    selectable: true,
    showLine: true
  };
};
var events = {
  denydrag: true,
  denydrop: true,
  dragend: true,
  transitionEnd: true
};
export var Tree = /*#__PURE__*/function (_Component) {
  _inheritsLoose(Tree, _Component);
  function Tree() {
    var _context;
    var _this;
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _Component.call.apply(_Component, _concatInstanceProperty(_context = [this]).call(_context, args)) || this;
    _this.nodes = useNodes();
    _this.checked = useChecked(_this.nodes.getNodes);
    _this.expanded = useExpanded(_this.nodes.getNodes);
    _this.selected = useSelected(_this.nodes.getNodes);
    _this.filter = useFilter(_this.nodes.getNodes, _this.expanded.get);
    _this.draggable = useDraggable();
    _this.transition = useTransitionEvent();
    _this.config = useConfigContext();
    return _this;
  }
  var _proto = Tree.prototype;
  _proto.getCheckedData = function getCheckedData(leafOnly) {
    if (leafOnly === void 0) {
      leafOnly = false;
    }
    return this.checked.getCheckedData(leafOnly);
  };
  _proto.getSelectedData = function getSelectedData() {
    return this.selected.getSelectedData();
  };
  _proto.expand = function expand(key) {
    var expandedKeys = this.expanded.get();
    expandedKeys.add(key);
    this.set('expandedKeys', _Array$from(expandedKeys));
  };
  _proto.shrink = function shrink(key) {
    var expandedKeys = this.expanded.get();
    expandedKeys.delete(key);
    this.set('expandedKeys', _Array$from(expandedKeys));
  };
  _proto.getNodes = function getNodes() {
    return this.nodes.getNodes();
  };
  _proto.expandAll = function expandAll() {
    this.expanded.expandAll();
  };
  _proto.onClick = function onClick(node) {
    if (node.data.disabled) return;
    var _this$get = this.get(),
      selectable = _this$get.selectable,
      checkbox = _this$get.checkbox;
    if (selectable) {
      this.selected.toggle(node);
    } else if (checkbox) {
      this.checked.toggle(node);
    } else {
      this.expanded.toggle(node);
    }
  };
  return Tree;
}(Component);
Tree.template = template;
Tree.typeDefs = typeDefs;
Tree.defaults = defaults;
Tree.events = events;
__decorate([bind], Tree.prototype, "onClick", null);